module.exports = require('./lib/type');



/*****************
 ** WEBPACK FOOTER
 ** ./~/type-detect/index.js
 ** module id = 128
 ** module chunks = 1
 **/